<template>
  <div class="button-wrapper">
    <button
      :class="buttonStyles"
      :type="type"
      :disabled="disabled"
      :autofocus="autofocus"
      @click="handleClick">
      <slot v-if="$slots['label']" name="label"></slot>
      <span v-else>
        <i v-if="icon" :class="{ 'fa': true, [icon]: true, 'mr-2': true }"></i>{{ label }}
      </span>
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      styles: {
        type: Object,
        default() {
          return {};
        },
      },

      type: {
        type: String,
        default: 'button',
      },

      disabled: {
        type: Boolean,
        default: false,
      },

      autofocus: {
        type: Boolean,
        default: false,
      },

      icon: {
        type: String,
      },

      label: {
        type: String,
      },

      onClick: {
        type: Function,
        required: true,
      },
    },

    computed: {
      buttonStyles() {
        const defaults = {
          'button': true,
          'button--icon': this.icon !== undefined,
        };

        return Object.assign(defaults, this.styles);
      },
    },

    methods: {
      handleClick(event) {
        this.onClick(event);
      },
    },
  };
</script>
